export const DATA = {
  fr: [
    {
      titleKey: 'shortcuts',
      type: 'group',
      children: [
        {
          titleKey: 'skills_and_qualities',
          type: 'link',
          url: 'competences-cv',
        },
        {
          titleKey: 'cv_layout',
          type: 'link',
          url: 'presentation-cv',
        },
        {
          titleKey: 'simple_cv_templates',
          type: 'link',
          url: 'cv-simple',
        },
        {
          titleKey: 'cv_examples_by_sector',
          type: 'link',
          url: 'exemples-cv',
        },
        {
          titleKey: 'cover_letter_example',
          type: 'link',
          url: 'exemple-lettre-de-motivation',
        },
        {
          titleKey: 'cover_letters_by_sector',
          type: 'link',
          url: 'recherche-lettre-motivation',
        },
      ],
    },
    {
      titleKey: 'services',
      type: 'group',
      children: [
        {
          titleKey: 'create_cv',
          type: 'link',
          url: 'https://app.makemycv.fr/create/resume',
        },
        {
          titleKey: 'create_cover_letter',
          type: 'link',
          url: 'https://app.makemycv.fr/create/cover-letter',
        },
      ],
    },
    {
      titleKey: 'about',
      type: 'group',
      children: [
        {
          titleKey: 'contact_us',
          type: 'link',
          url: 'contact',
        },
        {
          titleKey: 'unsubscribe',
          type: 'link',
          url: 'https://app.makemycv.fr/unsubscribe',
        },
        {
          titleKey: 'pricing',
          type: 'link',
          url: 'pricing',
        },
        {
          titleKey: 'terms_and_conditions',
          type: 'link',
          url: 'tos',
        },
        {
          titleKey: 'privacy_policy',
          type: 'link',
          url: 'privacy-policy',
        },
        {
          titleKey: 'legal_notices',
          type: 'link',
          url: 'legal',
        },
      ],
    },
  ],
  default: [
    {
      titleKey: 'services',
      type: 'group',
      children: [
        {
          titleKey: 'create_cv',
          type: 'link',
          url: 'https://app.makemycv.com/create/resume',
        },
        {
          titleKey: 'create_cover_letter',
          type: 'link',
          url: 'https://app.makemycv.com/create/cover-letter',
        },
      ],
    },
    {
      titleKey: 'about',
      type: 'group',
      children: [
        {
          titleKey: 'contact_us',
          type: 'link',
          url: 'contact',
        },
        {
          titleKey: 'unsubscribe',
          type: 'link',
          url: 'https://app.makemycv.com/unsubscribe',
        },
        {
          titleKey: 'pricing',
          type: 'link',
          url: 'pricing',
        },
        {
          titleKey: 'terms_and_conditions',
          type: 'link',
          url: 'tos',
        },
        {
          titleKey: 'privacy_policy',
          type: 'link',
          url: 'privacy-policy',
        },
        {
          titleKey: 'legal_notices',
          type: 'link',
          url: 'legal',
        },
      ],
    },
  ],
};

export const getFooterItems = (language = 'en') => {
  return DATA[language] || DATA.default;
};
